import { render, staticRenderFns } from "./TypographyWrapper.vue?vue&type=template&id=64a84da6&"
import script from "./TypographyWrapper.vue?vue&type=script&lang=js&"
export * from "./TypographyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TypographyWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports